import {
  GET_USER_NOTIFICATIONS_REQUESTED,
  GET_USER_NOTIFICATIONS_SUCCESSFUL,
  GET_USER_NOTIFICATIONS_FAILED,
  SET_USER_NOTIFICATIONS,
  GET_USER_PROFILE_REQUESTED,
  GET_USER_PROFILE_SUCCESSFUL,
  GET_USER_PROFILE_FAILED,
  SET_USER_PROFILE,
  COURSE_ENROLLMENT_REQUESTED,
  COURSE_ENROLLMENT_SUCCESSFUL,
  COURSE_ENROLLMENT_FAILED,
  TOGGLE_RESPONSE_MODAL,
  UNTOGGLE_RESPONSE_MODAL,
  GET_USER_ENROLLMENTS_REQUESTED,
  GET_USER_ENROLLMENTS_SUCCESSFUL,
  GET_USER_ENROLLMENTS_FAILED,
  GET_USER_CERTIFICATES_REQUESTED,
  GET_USER_CERTIFICATES_SUCCESSFUL,
  GET_USER_CERTIFICATES_FAILED,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  START_COURSE_REQUESTED,
  START_COURSE_SUCCESSFUL,
  START_COURSE_FAILED,
  GET_USER_COURSEWARES_REQUESTED,
  GET_USER_COURSEWARES_SUCCESSFUL,
  GET_USER_COURSEWARES_FAILED,
  GET_ENROLLMENTS_REQUESTED,
  GET_ENROLLMENTS_SUCCESSFUL,
  GET_ENROLLMENTS_FAILED,
  PATCH_NOTES_REQUESTED,
  PATCH_NOTES_SUCCESSFUL,
  PATCH_NOTES_FAILED,
  SHOW_TOAST,
  GET_KYC_ID_TEMPLATE_REQUESTED,
  GET_KYC_ID_TEMPLATE_SUCCESSFUL,
  GET_KYC_ID_TEMPLATE_FAILED,
  UPLOAD_KYC_ID_TEMPLATE_REQUESTED,
  UPLOAD_KYC_ID_TEMPLATE_SUCCESSFUL,
  UPLOAD_KYC_ID_TEMPLATE_FAILED,
  SUBMIT_MANUAL_KYC_REQUESTED,
  SUBMIT_MANUAL_KYC_SUCCESSFUL,
  SUBMIT_MANUAL_KYC_FAILED,
  SET_KYC_VERIFY_RETRIES,
  SET_USER_ERROR,
  GET_CLASS_SCHEDULE_REQUESTED,
  GET_CLASS_SCHEDULE_SUCCESSFUL,
  GET_CLASS_SCHEDULE_FAILED,
  START_EXAM_SUCCESSFUL,
  START_EXAM_REQUESTED,
  START_EXAM_FAILED,
  GET_EXAM_DETAILS_REQUESTED,
  GET_EXAM_DETAILS_SUCCESSFUL,
  GET_EXAM_DETAILS_FAILED,
  GET_COUNTRY_CODE_REQUESTED,
  GET_COUNTRY_CODE_SUCCESSFUL,
  GET_COUNTRY_CODE_FAILED,
  GET_DRAGONPAY_PROCESSORS_REQUESTED,
  GET_DRAGONPAY_PROCESSORS_SUCCESSFUL,
  GET_DRAGONPAY_PROCESSORS_FAILED,
  PAID_COURSE_ENROLLMENT_REQUESTED,
  PAID_COURSE_ENROLLMENT_SUCCESSFUL,
  PAID_COURSE_ENROLLMENT_FAILED,
  SHOW_CONFIRM_MODAL,
  HIDE_CONFIRM_MODAL,
  GET_MCLE_PROFILE_REQUEST,
  GET_MCLE_PROFILE_SUCCESS,
  GET_MCLE_PROFILE_FAILED,
  SET_EXAM_AS_SUBMITTED,
  UPDATE_MCLE_PROFILE_REQUEST,
  UPDATE_MCLE_PROFILE_SUCCESS,
  UPDATE_MCLE_PROFILE_FAILED,
  SET_MCLE_USER_PROFILE,
  GET_LAW_SCHOOLS_REQUEST,
  GET_LAW_SCHOOLS_SUCCESS,
  GET_LAW_SCHOOLS_FAILED,
  PAID_BUNDLE_ENROLLMENT_REQUESTED,
  PAID_BUNDLE_ENROLLMENT_SUCCESSFUL,
  PAID_BUNDLE_ENROLLMENT_FAILED,
  UPDATE_PROFILE_PHOTO_REQUESTED,
  UPDATE_PROFILE_PHOTO_SUCCESSFUL,
  UPDATE_PROFILE_PHOTO_FAILED,
  SHOW_PROFILE_PHOTO_MODAL,
  HIDE_PROFILE_PHOTO_MODAL,
  GET_WALLET_BALANCE_REQUESTED,
  GET_WALLET_BALANCE_SUCCESSFUL,
  GET_WALLET_BALANCE_FAILED,
  GET_WALLET_TRANSACTIONS_REQUESTED,
  GET_WALLET_TRANSACTIONS_SUCCESSFUL,
  GET_WALLET_TRANSACTIONS_FAILED,
  GET_USER_CLASSES_REQUESTED,
  GET_USER_CLASSES_SUCCESSFUL,
  GET_USER_CLASSES_FAILED,
  GET_USER_WALLET_NONCE_REQUESTED,
  GET_USER_WALLET_NONCE_SUCCESSFUL,
  GET_USER_WALLET_NONCE_FAILED,
  REGISTER_WALLET_ADDRESS_REQUESTED,
  REGISTER_WALLET_ADDRESS_SUCCESSFUL,
  REGISTER_WALLET_ADDRESS_FAILED,
  VERIFY_WALLET_ADDRESS_REQUESTED,
  VERIFY_WALLET_ADDRESS_SUCCESSFUL,
  VERIFY_WALLET_ADDRESS_FAILED,
  CLAIM_TOKENS_REQUESTED,
  CLAIM_TOKENS_SUCCESSFUL,
  CLAIM_TOKENS_FAILED,
  SET_WALLET_CONNECTED,
  SET_VERIFYING_ADDRESS,
  GET_PH_REGIONS_REQUESTED,
  GET_PH_REGIONS_SUCCESSFUL,
  GET_PH_REGIONS_FAILED,
  GET_IBP_CHAPTERS_REQUESTED,
  GET_IBP_CHAPTERS_SUCCESSFUL,
  GET_IBP_CHAPTERS_FAILED,
  GET_COMPLIANCE_PERIOD_REQUESTED,
  GET_COMPLIANCE_PERIOD_SUCCESSFUL,
  GET_COMPLIANCE_PERIOD_FAILED,
} from "./action-types"

import { parseErrorResponse } from "helpers/util"

const initialState = {
  notifications: {},
  isLoadingNotification: false,
  errors: "",
  isLoadingCourseEnrollment: false,
  userEnrolledCourses: {},
  isLoadingUserEnrolledCourses: false,
  isWalletConnected: false,
  responseModal: {
    showResponseModal: false,
    modalType: "",
    header: "",
    message: "",
    actionLabel: "",
    verified: true,
    showCloseModal: false,
    data: {},
  },
  confirmModal: {
    showModal: false,
    header: "",
    message: "",
    actionLabel: "",
    data: {},
  },
  isLoadingProfile: false,
  userDetails: {},
  isSubmitting: false,
  coursewareEnrollment: {},
  isLoadingCoursewareEnrollment: false,
  coursewareDetails: {},
  isLoadingCoursewareDetails: false,
  enrollments: [],
  isLoadingEnrollments: false,
  isPatchingNotes: false,
  toast: { message: "", type: "" },
  isLoadingID: false,
  idTemplate: [],
  kycVerifyRetries: 0,
  kycError: {},
  classSchedule: {},
  isLoadingClassSchedule: false,
  isStartExamRequested: false,
  examDetails: {},
  isLoadingCountryCode: false,
  countryCode: [],
  isFetchingDragonpayProcessors: false,
  dragonpayProcessors: {},
  processingPayment: false,
  mcleProfile: {},
  isLoadingMCLEProfile: false,
  lawSchools: [],
  isLoadingLawSchools: false,
  showProfilePhotoModal: false,
  classCalendar: [],
  isLoadingClasses: false,
  isFetchingWalletNonce: false,
  isVerifyingAddress: false,
  walletVerificationError: false,
  isLoadingPHRegions: false,
  phRegions: [],
  isLoadingIBPChapters: false,
  ibpChapters: [],
  isLoadingCompliancePeriod: false,
  compliancePeriod: [],
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_NOTIFICATIONS_REQUESTED: {
      return {
        ...state,
        isLoadingNotification: true,
      }
    }
    case GET_USER_NOTIFICATIONS_SUCCESSFUL: {
      return {
        ...state,
        isLoadingNotification: false,
      }
    }
    case GET_USER_NOTIFICATIONS_FAILED: {
      return {
        ...state,
        isLoadingNotification: false,
        errors: action.payload,
      }
    }
    case SET_USER_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.payload,
      }
    }
    case COURSE_ENROLLMENT_REQUESTED: {
      return {
        ...state,
        isLoadingCourseEnrollment: true,
      }
    }
    case COURSE_ENROLLMENT_SUCCESSFUL: {
      return {
        ...state,
        isLoadingCourseEnrollment: false,
      }
    }
    case COURSE_ENROLLMENT_FAILED: {
      return {
        ...state,
        isLoadingCourseEnrollment: false,
        errors: action.payload,
      }
    }
    case TOGGLE_RESPONSE_MODAL: {
      return {
        ...state,
        responseModal: {
          showResponseModal: true,
          modalType: action.payload.modalType,
          header: action.payload.header,
          message: action.payload.message,
          actionLabel: action.payload.actionLabel,
          action: action.payload.action,
          verified: action.payload.verified,
          data: action.payload.data,
          showCloseModal: action.payload.showCloseModal,
        },
        errors: "",
      }
    }
    case UNTOGGLE_RESPONSE_MODAL: {
      return {
        ...state,
        responseModal: {
          showResponseModal: false,
          modalType: "",
          header: "",
          message: "",
          actionLabel: " ",
          data: {},
          showCloseModal: false,
        },
        errors: "",
      }
    }

    case GET_USER_ENROLLMENTS_REQUESTED: {
      return {
        ...state,
        isLoadingEnrollments: true,
        enrollments: [],
      }
    }
    case GET_USER_ENROLLMENTS_SUCCESSFUL: {
      return {
        ...state,
        isLoadingEnrollments: false,
        enrollments: action.payload.data,
      }
    }
    case GET_USER_ENROLLMENTS_FAILED: {
      return {
        ...state,
        isLoadingEnrollments: false,
        enrollments: [],
      }
    }

    case GET_USER_CERTIFICATES_REQUESTED: {
      return {
        ...state,
        isLoadingCertificates: true,
        certificates: [],
      }
    }
    case GET_USER_CERTIFICATES_SUCCESSFUL: {
      return {
        ...state,
        isLoadingCertificates: false,
        certificates: action.payload.data,
      }
    }
    case GET_USER_CERTIFICATES_FAILED: {
      return {
        ...state,
        isLoadingCertificates: false,
        certificates: [],
      }
    }

    case GET_USER_PROFILE_REQUESTED:
      return {
        ...state,
        isLoadingProfile: true,
      }
    case GET_USER_PROFILE_SUCCESSFUL:
    case GET_USER_PROFILE_FAILED:
      return {
        ...state,
        isLoadingProfile: false,
      }
    case SET_USER_PROFILE:
      return {
        ...state,
        userDetails: action.payload,
      }

    case UPDATE_PROFILE_REQUEST:
    case UPLOAD_KYC_ID_TEMPLATE_REQUESTED:
    case UPDATE_MCLE_PROFILE_REQUEST:
    case SUBMIT_MANUAL_KYC_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
      }
    case UPDATE_PROFILE_SUCCESS:
    case UPDATE_PROFILE_FAILED:
    case UPDATE_MCLE_PROFILE_SUCCESS:
    case UPDATE_MCLE_PROFILE_FAILED:
    case SUBMIT_MANUAL_KYC_SUCCESSFUL:
    case SUBMIT_MANUAL_KYC_FAILED:
      return {
        ...state,
        isSubmitting: false,
      }

    case UPLOAD_KYC_ID_TEMPLATE_SUCCESSFUL:
      return {
        ...state,
        isSubmitting: false,
      }
    case UPLOAD_KYC_ID_TEMPLATE_FAILED:
      return {
        ...state,
        isSubmitting: false,
        kycError: parseErrorResponse(action.error),
      }

    case START_COURSE_REQUESTED: {
      return {
        ...state,
        isLoadingCoursewareEnrollment: true,
      }
    }
    case START_COURSE_SUCCESSFUL: {
      return {
        ...state,
        isLoadingCoursewareEnrollment: false,
        coursewareEnrollment: action.payload.data,
      }
    }
    case START_COURSE_FAILED: {
      return {
        ...state,
        isLoadingCoursewareEnrollment: false,
        errors: action.payload,
      }
    }

    case GET_USER_COURSEWARES_REQUESTED: {
      return {
        ...state,
        isLoadingCoursewareDetails: true,
        coursewareDetails: {},
      }
    }
    case GET_USER_COURSEWARES_SUCCESSFUL: {
      const { data } = action.payload
      if (data?.type === "ivideo") {
        const currentRetries = localStorage.getItem("max_attempts")
        if (data?.interactive_video?.max_attempts === 0) {
          localStorage.setItem("max_attempts", "unli")
        } else if (
          !currentRetries ||
          (currentRetries === "unli" &&
            data?.interactive_video?.max_attempts > 0)
        ) {
          localStorage.setItem(
            "max_attempts",
            data?.interactive_video?.max_attempts
          )
        }
      }
      return {
        ...state,
        isLoadingCoursewareDetails: false,
        coursewareDetails: data,
      }
    }
    case GET_USER_COURSEWARES_FAILED: {
      return {
        ...state,
        isLoadingCoursewareDetails: false,
        coursewareDetails: {},
      }
    }

    case GET_ENROLLMENTS_REQUESTED: {
      return {
        ...state,
        isLoadingEnrollments: true,
        enrollments: [],
      }
    }
    case GET_ENROLLMENTS_SUCCESSFUL: {
      return {
        ...state,
        isLoadingEnrollments: false,
        enrollments: action.payload.data,
      }
    }
    case GET_ENROLLMENTS_FAILED: {
      return {
        ...state,
        isLoadingEnrollments: false,
        enrollments: [],
      }
    }

    case PATCH_NOTES_REQUESTED: {
      return {
        ...state,
        isPatchingNotes: true,
      }
    }

    case PATCH_NOTES_SUCCESSFUL:
    case PATCH_NOTES_FAILED: {
      return {
        ...state,
        isPatchingNotes: false,
      }
    }

    case SHOW_TOAST: {
      return {
        ...state,
        toast: {
          message: action.payload.message,
          type: action.payload.type,
        },
        errors: "",
      }
    }

    case GET_KYC_ID_TEMPLATE_REQUESTED:
      return {
        ...state,
        isLoadingID: true,
      }
    case GET_KYC_ID_TEMPLATE_SUCCESSFUL:
      return {
        ...state,
        isLoadingID: false,
        idTemplate: Array.isArray(action.payload.data)
          ? action.payload.data?.map((id) => {
              return {
                label: id.template_name,
                value: id.id,
              }
            })
          : action.payload.data,
      }
    case GET_KYC_ID_TEMPLATE_FAILED:
      return {
        ...state,
        isLoadingID: false,
      }
    case SET_KYC_VERIFY_RETRIES:
      return {
        ...state,
        kycVerifyRetries: action.payload,
      }

    case SET_USER_ERROR: {
      return {
        ...state,
        errors: action.payload,
      }
    }

    case GET_CLASS_SCHEDULE_REQUESTED: {
      return {
        ...state,
        isLoadingClassSchedule: true,
        classSchedule: {},
      }
    }
    case GET_CLASS_SCHEDULE_SUCCESSFUL: {
      return {
        ...state,
        isLoadingClassSchedule: false,
        classSchedule: action.payload.data,
      }
    }
    case GET_CLASS_SCHEDULE_FAILED: {
      return {
        ...state,
        isLoadingClassSchedule: false,
        classSchedule: {},
      }
    }

    case START_EXAM_REQUESTED: {
      return {
        ...state,
        isStartExamRequested: true,
        examDetails: {},
      }
    }
    case START_EXAM_SUCCESSFUL: {
      return {
        ...state,
        isStartExamRequested: false,
        examDetails: action.payload.data,
      }
    }
    case START_EXAM_FAILED: {
      return {
        ...state,
        isStartExamRequested: false,
        examDetails: {},
      }
    }

    case GET_EXAM_DETAILS_REQUESTED: {
      return {
        ...state,
        isStartExamRequested: true,
        examDetails: {},
      }
    }
    case GET_EXAM_DETAILS_SUCCESSFUL: {
      return {
        ...state,
        isStartExamRequested: false,
        examDetails: action.payload.data,
      }
    }
    case GET_EXAM_DETAILS_FAILED: {
      return {
        ...state,
        isStartExamRequested: false,
        examDetails: {},
      }
    }

    case GET_COUNTRY_CODE_REQUESTED:
      return {
        ...state,
        isLoadingCountryCode: true,
      }
    case GET_COUNTRY_CODE_SUCCESSFUL:
      return {
        ...state,
        isLoadingCountryCode: false,
        countryCode: action.payload.data,
      }
    case GET_COUNTRY_CODE_FAILED:
      return {
        ...state,
        isLoadingCountryCode: false,
      }

    case GET_DRAGONPAY_PROCESSORS_REQUESTED:
      return {
        ...state,
        isFetchingDragonpayProcessors: true,
      }
    case GET_DRAGONPAY_PROCESSORS_SUCCESSFUL:
      return {
        ...state,
        isFetchingDragonpayProcessors: false,
        dragonpayProcessors: action.payload.data,
      }
    case GET_DRAGONPAY_PROCESSORS_FAILED:
      return {
        ...state,
        isFetchingDragonpayProcessors: false,
      }

    case GET_WALLET_BALANCE_REQUESTED:
      return {
        ...state,
        isFetchingWalletBalance: true,
        walletDetails: {},
      }
    case GET_WALLET_BALANCE_SUCCESSFUL:
      return {
        ...state,
        isFetchingWalletBalance: false,
        walletDetails: action.payload.data,
      }
    case GET_WALLET_BALANCE_FAILED:
      return {
        ...state,
        isFetchingWalletBalance: false,
        walletDetails: {},
      }

    case GET_WALLET_TRANSACTIONS_REQUESTED:
      return {
        ...state,
        isLoadingWalletTransactions: true,
        walletTransactions: [],
      }
    case GET_WALLET_TRANSACTIONS_SUCCESSFUL:
      return {
        ...state,
        isLoadingWalletTransactions: false,
        walletTransactions: action.payload.data,
      }
    case GET_WALLET_TRANSACTIONS_FAILED:
      return {
        ...state,
        isLoadingWalletTransactions: false,
        walletTransactions: [],
      }

    case PAID_COURSE_ENROLLMENT_REQUESTED:
      return {
        ...state,
        processingPayment: true,
      }
    case PAID_COURSE_ENROLLMENT_SUCCESSFUL:
      return {
        ...state,
        processingPayment: false,
      }
    case PAID_COURSE_ENROLLMENT_FAILED:
      return {
        ...state,
        processingPayment: false,
      }

    case PAID_BUNDLE_ENROLLMENT_REQUESTED:
      return {
        ...state,
        processingPayment: true,
      }
    case PAID_BUNDLE_ENROLLMENT_SUCCESSFUL:
      return {
        ...state,
        processingPayment: false,
      }
    case PAID_BUNDLE_ENROLLMENT_FAILED:
      return {
        ...state,
        processingPayment: false,
      }

    case SHOW_CONFIRM_MODAL:
      return {
        ...state,
        confirmModal: {
          showModal: true,
          modalType: action.payload.modalType,
          header: action.payload.header,
          message: action.payload.message,
          confirmLabel: action.payload.confirmLabel,
          confirmAction: action.payload.confirmAction,
          cancelLabel: action.payload.cancelLabel,
          cancelAction: action.payload.cancelAction,
          data: action.payload.data,
        },
        errors: {},
      }
    case HIDE_CONFIRM_MODAL:
      return {
        ...state,
        confirmModal: {
          showModal: false,
          modalType: "",
          header: "",
          message: "",
          confirmLabel: "",
          confirmAction: null,
          cancelLabel: "",
          cancelAction: null,
          data: {},
        },
        errors: {},
      }
    case SET_EXAM_AS_SUBMITTED:
      return {
        ...state,
        coursewareDetails: {
          ...state.coursewareDetails,
          exam_submission: action.payload,
        },
      }
    case GET_MCLE_PROFILE_REQUEST:
      return {
        ...state,
        isLoadingMCLEProfile: true,
      }
    case GET_MCLE_PROFILE_SUCCESS:
    case GET_MCLE_PROFILE_FAILED:
      return {
        ...state,
        isLoadingMCLEProfile: false,
      }
    case SET_MCLE_USER_PROFILE:
      return {
        ...state,
        mcleProfile: action.payload,
      }
    case GET_LAW_SCHOOLS_REQUEST:
      return {
        ...state,
        isLoadingLawSchools: true,
      }
    case GET_LAW_SCHOOLS_SUCCESS:
      return {
        ...state,
        isLoadingLawSchools: false,
        lawSchools: action.payload.data,
      }
    case GET_LAW_SCHOOLS_FAILED:
      return {
        ...state,
        isLoadingLawSchools: false,
      }
    case SHOW_PROFILE_PHOTO_MODAL:
      return {
        ...state,
        showProfilePhotoModal: true,
        errors: "",
      }
    case HIDE_PROFILE_PHOTO_MODAL:
      return {
        ...state,
        showProfilePhotoModal: false,
        errors: "",
      }

    case UPDATE_PROFILE_PHOTO_REQUESTED: {
      return {
        ...state,
        isSubmitting: true,
      }
    }
    case UPDATE_PROFILE_PHOTO_SUCCESSFUL: {
      return {
        ...state,
        isSubmitting: false,
        errors: "",
      }
    }
    case UPDATE_PROFILE_PHOTO_FAILED: {
      return {
        ...state,
        isSubmitting: false,
        errors: "",
      }
    }

    case GET_USER_CLASSES_REQUESTED: {
      return {
        ...state,
        isLoadingClasses: true,
        classCalendar: [],
        errors: "",
      }
    }
    case GET_USER_CLASSES_SUCCESSFUL: {
      return {
        ...state,
        isLoadingClasses: false,
        classCalendar: action.payload.data,
        errors: "",
      }
    }
    case GET_USER_CLASSES_FAILED: {
      return {
        ...state,
        isLoadingClasses: false,
        classCalendar: [],
        errors: "",
      }
    }

    case GET_USER_WALLET_NONCE_REQUESTED: {
      return {
        ...state,
        isFetchingWalletNonce: true,
        walletDetails: {
          ...state.walletDetails,
          nonce: null,
        },
      }
    }
    case GET_USER_WALLET_NONCE_SUCCESSFUL: {
      return {
        ...state,
        isFetchingWalletNonce: false,
        walletDetails: {
          ...state.walletDetails,
          nonce: action.payload.data.nonce,
        },
        errors: "",
      }
    }
    case GET_USER_WALLET_NONCE_FAILED: {
      return {
        ...state,
        isFetchingWalletNonce: false,
        walletDetails: {
          ...state.walletDetails,
          nonce: null,
        },
        errors: parseErrorResponse(action.error),
      }
    }

    case REGISTER_WALLET_ADDRESS_REQUESTED: {
      return {
        ...state,
        walletDetails: {
          ...state.walletDetails,
          nonce: null,
        },
        isSubmitting: true,
      }
    }
    case REGISTER_WALLET_ADDRESS_SUCCESSFUL: {
      return {
        ...state,
        isSubmitting: false,
        walletDetails: {
          ...state.walletDetails,
          nonce: action.payload.data.nonce,
        },
        errors: "",
      }
    }
    case REGISTER_WALLET_ADDRESS_FAILED: {
      return {
        ...state,
        isSubmitting: false,
        walletDetails: {
          ...state.walletDetails,
          nonce: null,
        },
      }
    }

    case VERIFY_WALLET_ADDRESS_REQUESTED: {
      return {
        ...state,
        isVerifyingAddress: true,
      }
    }
    case VERIFY_WALLET_ADDRESS_SUCCESSFUL: {
      return {
        ...state,
        isVerifyingAddress: false,
        walletVerificationError: false,
      }
    }
    case VERIFY_WALLET_ADDRESS_FAILED: {
      return {
        ...state,
        isVerifyingAddress: false,
        walletVerificationError: true,
      }
    }

    case CLAIM_TOKENS_REQUESTED: {
      return {
        ...state,
        isClaimingTokens: true,
      }
    }
    case CLAIM_TOKENS_SUCCESSFUL: {
      return {
        ...state,
        isClaimingTokens: false,
        tokenClaimingError: false,
      }
    }
    case CLAIM_TOKENS_FAILED: {
      return {
        ...state,
        isClaimingTokens: false,
        tokenClaimingError: true,
      }
    }

    case SET_WALLET_CONNECTED: {
      return {
        ...state,
        isWalletConnected: action.payload,
      }
    }

    case SET_VERIFYING_ADDRESS: {
      return {
        ...state,
        isVerifyingAddress: action.payload,
      }
    }

    case GET_PH_REGIONS_REQUESTED: {
      return {
        ...state,
        isLoadingPHRegions: true,
      }
    }
    case GET_PH_REGIONS_SUCCESSFUL: {
      return {
        ...state,
        isLoadingPHRegions: false,
        phRegions: action.payload?.data,
      }
    }
    case GET_PH_REGIONS_FAILED: {
      return {
        ...state,
        isLoadingPHRegions: false,
        phRegions: [],
      }
    }

    case GET_IBP_CHAPTERS_REQUESTED: {
      return {
        ...state,
        isLoadingIBPChapters: true,
      }
    }
    case GET_IBP_CHAPTERS_SUCCESSFUL: {
      return {
        ...state,
        isLoadingIBPChapters: false,
        ibpChapters: action.payload?.data,
      }
    }
    case GET_IBP_CHAPTERS_FAILED: {
      return {
        ...state,
        isLoadingIBPChapters: false,
        ibpChapters: [],
      }
    }

    case GET_COMPLIANCE_PERIOD_REQUESTED: {
      return {
        ...state,
        isLoadingCompliancePeriod: true,
      }
    }
    case GET_COMPLIANCE_PERIOD_SUCCESSFUL: {
      return {
        ...state,
        isLoadingCompliancePeriod: false,
        compliancePeriod: action.payload?.data,
      }
    }
    case GET_COMPLIANCE_PERIOD_FAILED: {
      return {
        ...state,
        isLoadingCompliancePeriod: false,
        compliancePeriod: [],
      }
    }
    default: {
      return state
    }
  }
}

export default userReducer
